import { SecondaryButton } from "@stenajs-webui/elements";
import { ActionPrompt, Popover } from "@stenajs-webui/tooltip";
import * as React from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refetchStatBoxesWithRateSheetsChanges } from "../../../customer-route-statistic-boxes/thunks/RefetchStatBoxesWithRateSheetsChanges";
import { useResetForms } from "@/features/route-agreement/hooks/UseResetForms";
import { routeAgreementOriginalSelectors } from "@/features/route-agreement/redux/redux";
import { customerRouteRedux } from "../redux";

interface Props {
  disabled?: boolean;
  onDiscard: () => void;
}

export const CustomerRouteDiscardChangesButton: React.FC<Props> = ({
  disabled,
  onDiscard,
}) => {
  const dispatch = useDispatch();

  const originalFormModel = useSelector(
    routeAgreementOriginalSelectors.getEntity
  );
  const { resetForms } = useResetForms(originalFormModel);

  const onDiscardHandler = useCallback(
    async (onRequestClose: () => void) => {
      onRequestClose();
      resetForms();
      onDiscard();
      await dispatch(customerRouteRedux.actions.discardChanges());
      await dispatch(refetchStatBoxesWithRateSheetsChanges());
    },
    [resetForms, onDiscard, dispatch]
  );

  return (
    <Popover
      trigger={"click"}
      placement={"bottom"}
      renderTrigger={(props) => (
        <SecondaryButton label={"Discard"} disabled={disabled} {...props} />
      )}
    >
      {({ onRequestClose }) => (
        <ActionPrompt
          onNo={onRequestClose}
          onYes={() => onDiscardHandler(onRequestClose)}
        />
      )}
    </Popover>
  );
};
